import { useContext } from 'react';
import AuthContext, { AuthContextValue } from '../components/auth-guard/JWTContext';

export const useAuth = (): AuthContextValue => useContext(AuthContext);
